// SPA entry point: initialise i18n, load the global stylesheet, and mount the
// React application. The built output is embedded into the Go binary.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
// Self-hosted display + body typefaces (Frutiger-Aero humanist pairing).
// Bundled by Vite and served from the binary, so they load under a strict CSP.
import '@fontsource/titillium-web/300.css';
import '@fontsource/titillium-web/400.css';
import '@fontsource/titillium-web/600.css';
import '@fontsource/titillium-web/700.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import './styles.css';
import App from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('root container missing');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
